export type GreenhouseIdAndName = {
  id: string;
  name: string | null;
};

type GreenhouseJobStageRawJson = {
  interviews: GreenhouseIdAndName[];
};

export type GreenhouseJobStage = {
  id: string;
  name: string | null;
  jobId: string;
  raw_json: GreenhouseJobStageRawJson;
};

export enum EditActionEnum {
  Show = "Show",
  Hide = "Hide",
}

export enum ActionEnum {
  SetInterviews = "SetInterviews",
  SetEditAction = "SetEditAction",
  SetEdits = "SetEdits",
  Back = "Back",
  Next = "Next",
  Cancel = "Cancel",
  Finish = "Finish",
}

export type InterviewEditsStateType = {
  interviewIds: string[];
  editAction: EditActionEnum;
  numStages: number;
  interviewName: string;
  titleOverride: string;
  descriptionOverride: string;
  activeStepIndex: number;
};

export type InterviewEditsDispatchType = {
  type: ActionEnum;
  interviewSelection?: {
    ids: string[];
    name: string;
    numStages: number;
  };
  editAction?: EditActionEnum;
  titleOverride?: string;
  descriptionOverride?: string;
};
